import { z } from 'zod';
import { type TranslationKey } from '@/i18n/translation-key.tsx';
import { EVENT_SPACE_TYPE } from '@/types/dtos/events/event-space.enum';

const updateEventDaySchema = z.object({
  id: z.string().optional(),
  startOffsetMinutes: z.number(),
  openOffsetMinutes: z.number(),
  endOffsetMinutes: z.number(),
});

const updateSpaceSchema = z
  .object({
    id: z.string().optional(), // if not provided, new space will be created
    type: z.enum(EVENT_SPACE_TYPE).optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    capacity: z.number().optional(),
    fromDate: z.iso.datetime().optional(),
    tillDate: z.iso.datetime().optional(),
    minTimeGap: z.number().optional(),
    location: z.string().optional(),
  })
  .refine(
    (data) =>
      (data.fromDate === undefined && data.tillDate === undefined) ||
      (data.fromDate !== undefined && data.tillDate !== undefined),
    {
      message: 'Both fromDate and tillDate must be provided together',
      path: ['fromDate', 'tillDate'],
    },
  );

export const updateEventSchemaFactory = (t: (key: TranslationKey) => string) => {
  return z.object({
    id: z.string(),
    version: z.number(),
    title: z.string().min(2, t('event.validation.titleNonEmpty')),
    description: z.string().optional(),
    location: z.string().optional(),
    days: z.array(updateEventDaySchema).optional(),
    spaces: z.array(updateSpaceSchema).optional(),
    startDate: z.iso.datetime(),
    endDate: z.iso.datetime(),
    timezone: z.string().min(1),
    durationDays: z.number(),
    type: z.string(),
    multiFlow: z.boolean(),
  });
};
